export default __webpack_public_path__ + "static/media/gas_tank.01f1b56e.webp";